export enum LeafletPaneName {
  tile = 'tile',
  overlay = 'overlay',
  shadow = 'shadow',
  marker = 'marker',
  tooltip = 'tooltip',
  popup = 'popup',
}

export const LeafletPaneZIndex: Record<LeafletPaneName, number> = {
  [LeafletPaneName.tile]: 200,
  [LeafletPaneName.overlay]: 400,
  [LeafletPaneName.shadow]: 500,
  [LeafletPaneName.marker]: 600,
  [LeafletPaneName.tooltip]: 650,
  [LeafletPaneName.popup]: 700,
};

export enum CustomPaneName {
  TrackRoutes = 'TrackRoutes',
  TrackPoints = 'TrackPoints',
  Beams = 'Beams',
  Objects = 'Objects',
}

export const CustomPaneZIndex: Record<CustomPaneName, number> = {
  [CustomPaneName.TrackRoutes]: LeafletPaneZIndex.overlay + 1,
  [CustomPaneName.TrackPoints]: LeafletPaneZIndex.overlay + 2,
  [CustomPaneName.Beams]: LeafletPaneZIndex.overlay + 3,
  [CustomPaneName.Objects]: LeafletPaneZIndex.marker + 1,
};
